var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2427 10.576L6 14.8186L1.75736 10.576C-0.585787 8.23278 -0.585787 4.43382 1.75736 2.09067C4.10051 -0.252474 7.89947 -0.252474 10.2427 2.09067C12.5858 4.43382 12.5858 8.23278 10.2427 10.576ZM6 7.66665C6.7364 7.66665 7.33333 7.06971 7.33333 6.33331C7.33333 5.59693 6.7364 4.99998 6 4.99998C5.2636 4.99998 4.66667 5.59693 4.66667 6.33331C4.66667 7.06971 5.2636 7.66665 6 7.66665Z",
    fill: "#797F86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.15dd4859dfb23e5c55f711d6f1cd28c0.svg";
export { ForwardRef as ReactComponent };